import {ApiClass} from "./ApiClass";
import {API_URL} from "../../constants/CONST";
import {User} from "../../models/User";


class FriendApiClass extends ApiClass {
    
    async getFriends(): Promise<User[] | null> {
        try {
            const res = await fetch(API_URL + "/friends", {
                method: "GET",
                headers: this.authHeader()
            })
            const data = await res.json()
            
            return data.map((user: any) => new User(user))
        } catch (e) {
            return null
        }
    }
    
    async getFriendRequests(): Promise<User[] | null> {
        try {
            const res = await fetch(API_URL + "/friends/requests", {
                method: "GET",
                headers: this.authHeader()
            })
            const data = await res.json()
            
            return data.map((user: any) => new User(user))
        } catch (e) {
            return null
        }
    }
    
    async getSentFriendRequests(): Promise<User[] | null> {
        try {
            const res = await fetch(API_URL + "/friends/requests/sent", {
                method: "GET",
                headers: this.authHeader()
            })
            const data = await res.json()
            
            return data.map((user: any) => new User(user))
        } catch (e) {
            return null
        }
    }
    
    async sendFriendRequest(userId: number): Promise<boolean> {
        try {
            const res = await fetch(API_URL + `/friends/requests/${userId}`, {
                method: "POST",
                headers: this.authHeader()
            })
            
            return res.ok
        } catch (e) {
            return false
        }
    }
    
    async acceptFriendRequest(userId: number): Promise<boolean> {
        try {
            const res = await fetch(API_URL + `/friends/requests/accept/${userId}`, {
                method: "POST",
                headers: this.authHeader()
            })
            
            return res.ok
        } catch (e) {
            return false
        }
    }
    
    async declineFriendRequest(userId: number): Promise<boolean> {
        try {
            const res = await fetch(API_URL + `/friends/requests/reject/${userId}`, {
                method: "POST",
                headers: this.authHeader()
            })
            
            return res.ok
        } catch (e) {
            return false
        }
    }
    
    async removeFriend(userId: number): Promise<boolean> {
        try {
            const res = await fetch(API_URL + `/friends/remove/${userId}`, {
                method: "DELETE",
                headers: this.authHeader()
            })

            return res.ok
        } catch (e) {
            return false
        }
    }
}

export const FriendApi = new FriendApiClass();
